import ActivateIcon from '@material-ui/icons/AssignmentTurnedIn';
import DeactivateIcon from '@material-ui/icons/DesktopAccessDisabled';
import { Button, Confirm, DeleteButton, ListButton, SaveButton, Toolbar, useInput, useNotify, useTranslate } from 'react-admin';
import { useForm } from 'react-final-form';
import { GCloneButton, Spacing } from '..';
import { isCreate } from '../utils/fn';
import { WithPermissions } from "@react-admin/ra-rbac";
import { useState } from 'react';

const clean = ({ onActivate, onDeactivate, onBeforeSave, type, hasSave, hasList, hasDeactivate, hasActivate, hasDuplicate, hasDelete, hasToolbar, ...props }) => props

const check = (checkAttribute, record) => {
    if (typeof checkAttribute === "string") {
        return checkAttribute === "true";
    } else if (typeof checkAttribute === "boolean") {
        return checkAttribute;
    } else {
        return checkAttribute(record);
    }
};

const DefaultToolbar = (props) => {
    const [action, setAction] = useState(null);
    const translate = useTranslate();
    const notify = useNotify();
    const {
        input: { onChange }
    } = useInput({ source: "status" });
    const { resource, record } = props;
    const resourceName = translate(`resources.${resource}.name`, { smart_count: 1 });
    const showActivate = check(props.hasActivate, record);
    const showDeactivate = check(props.hasDeactivate, record);
    const showDelete = check(props.hasDelete, record);
    const showDuplicate = check(props.hasDuplicate, record) && !isCreate();
    const showSave = check(props.hasSave, record);
    const showList = check(props.hasList, record);
    const propsCleaned = clean(props);

    const form = useForm();
    const changeStatus = async (status) => {
        const result = status === "enabled" ? await props.onActivate(form) : await props.onDeactivate(form);
        let isValid;
        let errorMessage = `resources.${status}.generic`;
        let messageArgs;
        if (typeof result === "boolean") {
            isValid = result;
        } else if (typeof result === "object") {
            errorMessage = "resources.alreadyTranslate";
            let message = "";
            for (const error of result) {
                message += `${translate(error.key, error.args)}\n`;
            }
            messageArgs = { message };
            isValid = result.length === 0;
        } else {
            errorMessage = `resources.${status}.wrongReturnType`;
            isValid = false;
        }
        if (isValid) {
            onChange(status);
            await props.handleSubmitWithRedirect(false);
        } else {
            notify(errorMessage, {
                type: "error",
                autoHideDuration: 20000,
                messageArgs
            });
        }
    };
    if (!check(props.hasToolbar, record)) {
        return <div />;
    } else {
        let redirect = isCreate() ? "edit" : false;
        if (props.redirect) {
            if (props.redirect.startsWith("@")) {
                redirect = props.redirect.substring(1);
            } else if (typeof props.redirect === 'function') {
                redirect = props.redirect
            }
        }
        const handleConfirm = async () => {
            if (action === "deactivate") {
                await changeStatus("disabled");
            }
        };
        return <Toolbar {...propsCleaned}>
            <Confirm
                isOpen={action !== null}
                title={action ? translate(`resources.common.actionTitle.${action}`, { resourceName }) : ""}
                content={action ? translate(`resources.common.actionContent.${action}`, { resourceName }) : ""}
                onConfirm={handleConfirm}
                onClose={() => {
                    setAction(null);
                }}
            />
            {showActivate && <WithPermissions action="edit" resource={resource}><Button onClick={() => changeStatus("enabled")} disabled={!propsCleaned.pristine} variant="contained" label="resources.activate" className="activate"><ActivateIcon /></Button></WithPermissions>}
            {showDeactivate && <WithPermissions action="edit" resource={resource}><Button onClick={() => setAction("deactivate")} variant="contained" label="resources.deactivate" className="deactivate"><DeactivateIcon /></Button></WithPermissions>}
            {showSave && <WithPermissions action="edit" resource={resource}><SaveButton redirect={redirect} disabled={propsCleaned.pristine} /></WithPermissions>}
            {showDuplicate && <GCloneButton />}
            {showList && <WithPermissions action="list" resource={resource}><ListButton variant="outlined" /></WithPermissions>}
            <Spacing />
            {showDelete && <WithPermissions action="delete" resource={resource}><DeleteButton size="medium" /></WithPermissions>}
        </Toolbar>
    }
};

DefaultToolbar.defaultProps = {
    onActivate: () => true,
    onDeactivate: () => true,
    hasDuplicate: false,
    hasSave: (record) => {
        return !record["status"] || record["status"] === "draft";
    },
    hasActivate: (record) => {
        return record["status"] === "draft";
    },
    hasDeactivate: (record) => {
        return record["status"] === "enabled";
    },
    hasDelete: (record) => {
        return !record["status"] || record["status"] === "draft";
    },
    hasList: true,
    hasToolbar: true
};

export default DefaultToolbar;